import UserClient98 from '@/generated/controls/user/UserClient98.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  components: {},
  extends: UserClient98
})
